import {Box, LinearProgress, Typography} from "@mui/material";
import {useEffect} from "react";

export default function AppLinearProgressWithLabel(props) {
    useEffect(() => {
        // console.log(props);
    }, [props])
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }} bgcolor="#8c3b61">
            <Box sx={{ width: '100%', mr: 1 }}>
                <LinearProgress variant="determinate" {...props} />
            </Box>
            <Box sx={{ minWidth: 30 }}>
                <Typography variant="body2" color="#fefefe">{`${Math.round(
                    props.value,
                )}%`}</Typography>
            </Box>
        </Box>
    );
}